export const userProfile = () => async (dispatch) => {
  await dispatch({
    type: "LOAD_LOGIN_SUCCESS",
    users: [],
  });
};
